import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Represents the view for other expenses.
 */
export default class otherExpensesView extends JetView {
    /**
     * Configures the view layout and data.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting
        const vthis = this; // Reference to the current instance
        const data = []; // Initial data array
        let totalBets = 0; // Total bets initialized
        totalBets = data // Calculate total bets
            .map((item) => item.Bets)
            .reduce((prev, curr) => prev + curr, 0);
        let totalPrize = 0; // Total prize initialized
        totalPrize = data // Calculate total prize
            .map((item) => item.Prize)
            .reduce((prev, curr) => prev + curr, 0);

        // Configuration for the first data table
        var gridProduct1 = {
            rows: [
                {
                    view: 'datatable',
                    id: 'gridProduct1',
                    css: 'webix_header_border webix_data_border',
                    autoheight: true,
                    scroll: false,
                    columns: [
                        {
                            id: 'Product',
                            header: {
                                text: _('Productos'), // Localized header
                                css: { 'text-align': 'center' },
                            },
                            css: { background: '#f3f3f3;' },
                            width: 300,
                        },
                        {
                            id: 'User',
                            header: {
                                text: _('Usuario que lo creo'), // Localized header
                                css: { 'text-align': 'center' },
                            },
                            width: 200,
                        },
                        {
                            id: 'Bets',
                            header: {
                                text: _('Ingresos'), // Localized header
                                css: { 'text-align': 'center' },
                            },
                            minWidth: 150,
                            fillspace: true,
                        },
                        {
                            id: 'Prize',
                            header: {
                                text: _('Egresos'), // Localized header
                                css: { 'text-align': 'center' },
                            },
                            minWidth: 150,
                            fillspace: true,
                        },
                    ],
                    data: data, // Data for the table
                },
            ],
        };

        /**
         * Updates the total bets from both grids.
         * @returns {number} The total bets.
         */
        function updateSummBets() {
            var summ = 0;
            $$('gridProduct1').data.each(function (row) {
                summ += row.Bets * 1 || 0; // Sum bets from gridProduct1
            });
            $$('gridProduct2').data.each(function (row) {
                summ += row.Bets * 1 || 0; // Sum bets from gridProduct2
            });
            return summ; // Return total bets
        }

        /**
         * Updates the total prize from both grids.
         * @returns {number} The total prize.
         */
        function updateSummPrize() {
            var summ = 0;
            $$('gridProduct1').data.each(function (row) {
                summ += row.Prize * 1 || 0; // Sum prize from gridProduct1
            });
            $$('gridProduct2').data.each(function (row) {
                summ += row.Prize * 1 || 0; // Sum prize from gridProduct2
            });
            return summ; // Return total prize
        }

        const data2 = [
            // Initial data for the second grid
            {
                id: '1',
                Product: 'Inbet',
                Bets: 0,
                Prize: 0,
            },
            {
                id: '2',
                Product: 'Producto 2',
                Bets: 0,
                Prize: 0,
            },
            {
                id: '3',
                Product: 'Producto 3',
                Bets: 0,
                Prize: 0,
            },
            {
                id: '4',
                Product: 'Producto 4',
                Bets: 0,
                Prize: 0,
            },
        ];

        /**
         * Checks if a value is not empty.
         * @param {any} value - The value to check.
         * @returns {boolean} True if not empty, otherwise false.
         */
        function notEmpty(value) {
            return value != ''; // Check for non-empty value
        }

        /**
         * Checks if a value is a positive integer.
         * @param {number} value - The value to check.
         * @returns {boolean} True if positive integer, otherwise false.
         */
        function positiveInteger(value) {
            return value >= 0; // Check for non-negative value
        }

        // Configuration for the second data table
        var gridProduct2 = {
            rows: [
                {
                    view: 'datatable',
                    autoConfig: true,
                    id: 'gridProduct2',
                    editable: true,
                    css: 'webix_header_border webix_data_border',
                    columns: [
                        { id: 'Product', width: 300 },
                        { id: 'User', width: 200 },
                        {
                            id: 'Bets',
                            editor: 'text',
                            minWidth: 150,
                            fillspace: true,
                        },
                        {
                            id: 'Prize',
                            editor: 'text',
                            minWidth: 150,
                            fillspace: true,
                        },
                    ],
                    header: false,
                    autoheight: true,
                    rules: {
                        Bets: positiveInteger, // Validation rule for Bets
                        Prize: positiveInteger, // Validation rule for Prize
                    },
                    ready: function () {
                        this.validate(); // Validate on ready
                    },
                },
            ],
        };

        // Event listener for updating total bets
        this.on(this.app, 'updateSummBets', (sum) => {
            var total = totalBets + updateSummBets(); // Calculate new total
            vthis.app.callEvent('totalIncomesProducts:sum', [{ total }]); // Trigger event with total
        });

        // Event listener for updating total prize
        this.on(this.app, 'updateSummPrize', (sum) => {
            var total = totalPrize + updateSummPrize(); // Calculate new total
            vthis.app.callEvent('totalExpensesProducts:sum', [{ total }]); // Trigger event with total
        });

        return {
            rows: [gridProduct1, gridProduct2], // Return the layout
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        var vthis = this; // Reference to the current instance
        $$('gridProduct2').data.attachEvent(
            'onStoreUpdated', // Event for data store updates
            function (id, obj, mode) {
                if (mode == 'add' || mode == 'update' || mode == 'delete') {
                    if ($$('gridProduct2').validate()) {
                        // Validate data
                        vthis.app.callEvent('updateSummBets', [{}]); // Update bets
                        vthis.app.callEvent('updateSummPrize', [{}]); // Update prize
                        vthis.app.callEvent('productsObject', [{}]); // Trigger products object event
                    }
                }
            },
        );

        // Delay to ensure data is updated after initialization
        webix.delay(
            function () {
                vthis.app.callEvent('updateSummBets', [{}]); // Update bets
                vthis.app.callEvent('updateSummPrize', [{}]); // Update prize
                vthis.app.callEvent('productsObject', [{}]); // Trigger products object event
            },
            '',
            '',
            200,
        );

        // AJAX request to fetch products by bet shop
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetProductsByBetShop', // API endpoint
                '{"BetShopId":' + profile.AgentId + ',"State":"A"}', // Request payload
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error handling
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        for (var i = 0; i < resp.Data.length; i++) {
                            resp.Data[i].id = resp.Data[i].Id; // Map ID
                            resp.Data[i].Product = resp.Data[i].Product; // Map Product
                            resp.Data[i].Bets = 0; // Initialize Bets
                            resp.Data[i].Prize = 0; // Initialize Prize
                            delete resp.Data[i].Id; // Clean up response data
                            delete resp.Data[i].State;
                            delete resp.Data[i].Name;
                            delete resp.Data[i].Account;
                            delete resp.Data[i].Provider;
                        }
                        console.log(resp.Data); // Log response data
                        $$('gridProduct2').define('data', resp.Data); // Define data for gridProduct2
                    },
                },
            );

        /**
         * Loads the table with data based on the filter.
         * @param {Object} filter - The filter criteria.
         */
        function loadTable(filter) {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(
                    devConfig.geturlApi() + 'Accounting/GetProductsPlatformByBetShopToday', // API endpoint
                    '{"BetShopId":' + profile.AgentId + ',"State":"A", "IdCashier":"' + filter.Id + '"}', // Request payload
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Error handling
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse response
                            $$('gridProduct1').clearAll(); // Clear existing data
                            $$('gridProduct1').define('data', resp.Data); // Define new data for gridProduct1
                            vthis.app.callEvent('updateSummBets', [{}]); // Update bets
                            vthis.app.callEvent('updateSummPrize', [{}]); // Update prize
                        },
                    },
                );
        }

        loadTable({ Id: '' }); // Initial load of the table

        // Event listener for cashier view changes
        this.on(this.app, 'viewCashier', (filter) => {
            loadTable(filter); // Load table with new filter
        });
    }
}

// FILE DOCUMENTED
